/* RESPONSIBLE TEAM: team-frontend-tech */
/* === ⚠️ THIS FILE CURRENTLY USES DEPRECATED PATTERNS ⚠️ === */
/* === 🔗 For more information visit https://go.inter.com/ember-best-practices 🔗 */
/* === 🚀 Please consider refactoring & removing some of the comments below when working on this file 🚀 */
/* eslint-disable @intercom/intercom/no-bare-strings */
import { helper } from '@ember/component/helper';

export function aggregationText(aggregationType) {
  return {
    avg: 'Average',
    max: 'Max',
    min: 'Min',
    median: 'Median',
  }[aggregationType];
}

function aggregationTextHelper([aggregationType]) {
  return aggregationText(aggregationType);
}

export default helper(aggregationTextHelper);
